import { accentFillActiveBehavior, accentFillHoverBehavior, accentFillRestBehavior, neutralFillActiveBehavior, neutralFillFocusBehavior, neutralFillHoverBehavior, neutralFillRestBehavior, neutralFocusBehavior, neutralForegroundActiveBehavior, neutralForegroundRestBehavior, neutralOutlineRestBehavior, } from "@fluentui/web-components";
import { display, focusVisible, forcedColorsStylesheetBehavior, } from "@microsoft/fast-foundation";
import { css } from "@microsoft/fast-element";
import { SystemColors } from "@microsoft/fast-web-utilities";
export const FeedNavigationItemStyles = css `
    ${display("flex")} :host {
        font-family: var(--body-font);
        outline: none;
    }

    .control {
        font-size: var(--type-ramp-base-font-size);
        line-height: var(--type-ramp-base-line-height);
        box-sizing: border-box;
        justify-content: center;
        align-items: center;
        white-space: nowrap;
        outline: none;
        text-decoration: none;
        cursor: pointer;
        color: ${neutralForegroundRestBehavior.var};
        fill: ${neutralForegroundRestBehavior.var};
        border-bottom: 2px solid transparent;
    }

    :host([active]) .control {
        border-bottom-color: ${accentFillActiveBehavior.var};
        color: ${neutralForegroundActiveBehavior.var};
        fill: ${neutralForegroundActiveBehavior.var};
        font-weight: 600;
    }

    :host([active]) .control:hover {
        border-bottom-color: ${accentFillHoverBehavior.var};
    }

    :host([active]) .control:active {
        border-bottom-color: ${accentFillActiveBehavior.var};
    }

    .control:hover {
        border-bottom-color: ${neutralFillHoverBehavior.var};
    }

    .control:active {
        border-bottom-color: ${neutralForegroundActiveBehavior.var};
    }

    .control:${focusVisible} {
        outline: none;
        border-bottom-color: ${neutralFocusBehavior.var};
    }

    .control::-moz-focus-inner {
        border: 0;
    }

    :host(.disabled) {
        opacity: var(--disabled-opacity);
    }

    ::slotted([slot="start"]) {
        vertical-align: middle;
    }
`.withBehaviors(accentFillActiveBehavior, accentFillHoverBehavior, accentFillRestBehavior, neutralFillActiveBehavior, neutralFillFocusBehavior, neutralFillHoverBehavior, neutralFillRestBehavior, neutralFocusBehavior, neutralForegroundRestBehavior, neutralOutlineRestBehavior, forcedColorsStylesheetBehavior(css `
            .control {
                border-bottom-color: ${SystemColors.ButtonFace};
                color: ${SystemColors.LinkText};
                fill: currentColor;
            }

            :host([active]) .control {
                border-bottom-color: ${SystemColors.LinkText};
                color: ${SystemColors.LinkText};
                fill: currentColor;
            }
        `));
